// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-w7wWcCy8","fhlx":"fhlx-TnzUuCI9 clearfix","mr24":"mr24-1500pOaX fl","img":"img-3hKlH_ED","lx_word":"lx_word-xnR3MOis fl"};